import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import BaseListingRendererWithPlugins from 'nav/expanded/BaseListingRendererWithPlugins';
import {
  ColumnAccessorKey,
  ColumnConfiguration,
  ListingRendererType,
  ListingTypes,
} from 'nav/expanded/ListingRendererConstants';
import {SortKey} from 'search/SearchConstants';
import {getColumnHeaderFromSortKey} from 'search/SortUtil';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {TABLE_ROW_BODY_HEIGHT} from 'ui-library/scrollable/ScrollableTableConstants';
import {DatetimeTableCell} from 'ui-library/scrollable/table-cells/DatetimeTableCell';
import {BasicEvent} from 'util/Types';

export default class CollectionListingRenderer extends BaseListingRendererWithPlugins<ListingRendererType.COLLECTION> {
  listingRendererType = ListingRendererType.COLLECTION;

  getNonPluginColumnConfigurations(
    items: Array<ListingTypes[ListingRendererType.COLLECTION]>,
    extras: unknown
  ): Array<ColumnConfiguration<ListingTypes[ListingRendererType.COLLECTION]>> {
    return [
      {
        column: {
          header: getColumnHeaderFromSortKey(SortKey.SORT_NAME_KEY),
          accessorKey: ColumnAccessorKey.NAME,
          flexGrow: 1,
          isSortable: true,
          sortKey: SortKey.SORT_NAME_KEY,
        },
        render: (item) => <div>{item.name}</div>,
      },
      {
        column: {
          accessorKey: ColumnAccessorKey.OWNER,
          header: 'Owner',
          flexGrow: 1,
          width: 200,
          isCollapsible: false,
        },
        render: (item) => <div>{item.ownerJson.name}</div>,
      },
      {
        column: {
          accessorKey: ColumnAccessorKey.CREATED_AT,
          header: getColumnHeaderFromSortKey(SortKey.SORT_CREATED_AT_KEY),
          flexGrow: 1,
          isSortable: true,
          sortKey: SortKey.SORT_CREATED_AT_KEY,
        },
        render: (item) => <DatetimeTableCell datetime={item.createdAt} showTimeInCell={false} />,
      },
      {
        column: {
          accessorKey: ColumnAccessorKey.MODIFIED_AT,
          header: getColumnHeaderFromSortKey(SortKey.SORT_MODIFIED_AT_KEY),
          flexGrow: 1,
          isSortable: true,
          sortKey: SortKey.SORT_MODIFIED_AT_KEY,
        },
        render: (item) => <DatetimeTableCell datetime={item.modifiedAt} showTimeInCell={false} />,
      },
    ];
  }

  getNonPluginRowContentHeight(): number {
    return TABLE_ROW_BODY_HEIGHT;
  }

  openContextMenu(
    item: ListingTypes[ListingRendererType.COLLECTION],
    e: BasicEvent,
    options: unknown
  ): void {}

  renderIcon(item: ListingTypes[ListingRendererType.COLLECTION], options: unknown): JSX.Element {
    return (
      <BenchlingIcon icon={ModelTypeConstants.TEMPLATE_COLLECTION} className="scrollableTable-cell-icon" />
    );
  }
}
